
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"viewBox":"0 0 18 18","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}},[_c('defs',[_c('path',{attrs:{"d":"M12.686 22.433l-4.54-4.54a.5.5 0 01.707-.707l3.833 3.833L23.56 10.146a.5.5 0 01.707.707l-11.58 11.58z","id":"tick_svg__a"}})]),_c('use',{attrs:{"stroke":"#000","fill":"#1D1D1B","xlink:href":"#tick_svg__a","transform":"translate(-7 -9)","fill-rule":"evenodd"}})])
      }
    
      }
    